"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M10 9h4v4h3l-5 4-5-4h3V9z\" fill=\"#000\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 14a6 6 0 006 6h13a5 5 0 00.352-9.988A7.502 7.502 0 005.347 8.035 6 6 0 000 14zm17.392-3.593l.3 1.495 1.521.105A3 3 0 0119 18H6a4 4 0 01-.438-7.976l1.063-.116.495-.948a5.503 5.503 0 0110.272 1.446z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;